var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.35968,
    y: 1.2793,
    width: 57.311,
    height: 57.5405,
    rx: 7.5,
    fill: "#CF23C2",
    fillOpacity: 0.1,
    stroke: "#CF23C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8212 49.1892H38.3434L36.6791 40.7489L38.3434 32.3086C44.5519 35.3752 48.8212 41.7951 48.8212 49.1892Z",
    fill: "#CF23C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8469 32.3086L37.5113 40.749L35.8469 49.1893H30.0284L29.183 35.292L33.5179 32.3086H35.8469Z",
    fill: "#CF23C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2101 32.3086L22.5457 40.749L24.2101 49.1893H30.0285L30.0152 35.292L26.5125 32.3086H24.2101Z",
    fill: "#CF23C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4172 35.2916L33.3761 46.1033L30.0152 49.189L29.183 34.4595L31.4172 35.2916Z",
    fill: "#600C59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6132 35.2916L26.6543 46.1033L30.0152 49.189V34.4595L28.6132 35.2916Z",
    fill: "#600C59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5179 32.3086L31.4172 35.292H30.0152L29.183 33.8004L30.0152 32.3086H33.5179Z",
    fill: "#600C59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5125 32.3086L28.6133 35.292H30.0152V32.3086H26.5125Z",
    fill: "#600C59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3434 32.3086H35.8469V49.1893H38.3434V32.3086Z",
    fill: "#CF23C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2092 49.1892H21.687L23.3513 40.7489L21.687 32.3086C15.4786 35.3752 11.2092 41.7951 11.2092 49.1892Z",
    fill: "#CF23C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1835 32.3086H21.687V49.1893H24.1835V32.3086Z",
    fill: "#CF23C2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0152 10.9092L29.183 26.554L39.1488 24.8897L40.7642 15.1949L36.2842 17.1782L30.0152 10.9092Z",
    fill: "#CF23C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0152 10.9092V26.554L20.8816 24.8897L19.2663 15.1949L23.7462 17.1782L30.0152 10.9092Z",
    fill: "#600C59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0152 29.8827H38.3169L39.1488 24.8896H30.0152L27.5187 27.3862L30.0152 29.8827Z",
    fill: "#600C59"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0152 29.8827H21.7135L20.8816 24.8896H30.0152V29.8827Z",
    fill: "#CF23C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionary);
export default __webpack_public_path__ + "static/media/visionary.b9b07e3dac906539fbce701a52be2a21.svg";
export { ForwardRef as ReactComponent };